<template>
  <transition name="fade">
    <div class="layer" v-if="visible" :style="{zIndex:zIndex}">
      <transition name="fade-transform-top">
        <div v-if="dialogShowing" class="map-container" :style="{marginTop:top}">
          <div class="map" ref="map"></div>
          <div class="selected-value" v-if="selectedLocation">
            {{ selectedLocation[0] }},{{ selectedLocation[1] }}
          </div>
          <div class="selected-value" v-if="!selectedLocation">请在地图上选点</div>
          <button-line>
            <el-button @click="hideSelector">取消</el-button>
            <el-button type="primary" :disabled="!selectedLocation" @click="confirmSelect">确定</el-button>
          </button-line>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import VectorSource from "ol/source/Vector";
import Map from "ol/Map";
import Feature from "ol/Feature";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import VectorLayer from "ol/layer/Vector";
import View from "ol/View";
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import ButtonLine from "@/components/ButtonLine";

const iconStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: require('@/assets/img/location.png'),
    scale: 0.6
  })
});

export default {
  name: "LocationSelector",
  components: {ButtonLine},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 4000
    },
    top: {
      type: String,
      default: '3vh'
    },
    value: {
      type: String | Array[Number]
    }
  },
  model: {
    prop: 'visible',
    event: 'changeVisible'
  },
  data() {
    return {
      dialogShowing: false,
      map: null,
      source: null,
      feature: null,
      selectedLocation: null
    }
  },
  methods: {
    hideSelector() {
      this.$emit('changeVisible', false);
    },
    confirmSelect() {
      if (!this.selectedLocation) {
        return;
      }
      this.$emit('select', {
        longitude: this.selectedLocation[0],
        latitude: this.selectedLocation[1]
      });
      this.$emit('changeVisible', false);
    },
    initMap() {
      this.source = new VectorSource({
        wrapX: false
      });
      if (this.map) {
        try {
          this.map.dispose();
          this.map = null;
        } catch (e) {
        }
      }
      this.map = new Map({
        layers: [
          new TileLayer({
            source: new XYZ({
              url: "https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}"
            })
          }),
          new VectorLayer({
            source: this.source
          })
        ],
        target: this.$refs['map'],
        view: new View({
          projection: 'EPSG:4326',
          center: [116.084412, 38.685325],
          zoom: 12
        }),
      });
      this.initValue();
      this.map.on('singleclick', (e) => {
        if (this.feature) {
          this.source.removeFeature(this.feature);
        }
        this.feature = null;
        let feature = new Feature({
          geometry: new Point(e.coordinate),
        });
        this.selectedLocation = e.coordinate;
        feature.setStyle(iconStyle);
        this.source.addFeature(feature);
        this.feature = feature;
      });
    },
    initValue() {
      if (!this.value) {
        return;
      }
      this.selectedLocation = this.value;
      let coordinate;
      if (this.value instanceof String) {
        let arr = this.value.split(",");
        if (arr.length < 2) {
          return;
        }
        arr[0] = parseFloat(arr[0]);
        arr[1] = parseFloat(arr[1]);
        coordinate = arr;
      } else {
        if (this.value.length < 2) {
          return;
        }
        coordinate = this.value.slice(0, 2);
      }
      let feature = new Feature({
        geometry: new Point(coordinate),
      });
      this.selectedLocation = coordinate;
      feature.setStyle(iconStyle);
      this.source.addFeature(feature);
      this.feature = feature;
    }
  },
  watch: {
    visible(value) {
      setTimeout(() => {
        this.dialogShowing = value;
        this.$nextTick(() => {
          if (value) {
            this.initMap();
          }
        });
      }, 0);
    }
  },
  mounted() {
    let $el = this.$el;
    this.dialogShowing = this.visible;
    document.body.appendChild($el);
  },
  destroyed() {
    document.body.removeChild(this.$el);
  }
}
</script>

<style lang="scss" scoped>
.fade-transform-top-leave-active,
.fade-transform-top-enter-active {
  transition: all 300ms;
}

.fade-transform-top-leave-to,
.fade-transform-top-enter {
  opacity: 0;
  transform: translateY(-30px);
}

.layer {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  width: 100%;
  height: 100%;
}

.map {
  width: 600px;
  height: 400px;
}

.map-container {
  position: relative;
  width: 660px;
  background-color: #ffffff;
  margin: 0 auto;
  padding: 20px;
  border-radius: 12px;
}

.selected-value {
  font-size: 14px;
  color: #666666;
  height: 24px;
  line-height: 24px;
}
</style>
